import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url, inputData) =>
  await AxiosConfig.create('post', url).call(inputData).getResponseData();

function useInbox(userID, inputData) {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    `/inbox/${userID}`,
    (url) => fetcher(url, inputData),
    {
      refreshInterval: import.meta.env.VITE_API_POLLING_INTERVAL,
      revalidateOnFocus: true,
    }
  );

  return {
    data: data?.data,
    res: {
      status: data?.code || error?.response?.status,
      statusText: data?.message || error?.response?.statusText,
    },
    isLoading,
    isValidating,
    error,
    mutate: mutate,
  };
}

export default useInbox;
